//
// Globally declared components
//

import { ClientTable, ServerTable } from "v-tables-3";
import VueSecureHTML from "vue-html-secure";
import Aura from "@primeuix/themes/aura";
import PrimeVue from "primevue/config";
// import { BTooltip, BModal, BPopover, BCollapse, BButtonGroup, BDropdownItem, BDropdown } from "@/bv";

import BushelBtn from "@/components/common/BushelBtn.vue";
import BushelCard from "@/components/common/cards/BushelCard.vue";
import Loading from "@/components/common/loaders/Default.vue";
import BushelTextInput from "@/components/common/forms/BushelTextInput.vue";
import BushelSelect from "@/components/common/forms/BushelSelect.vue";
import BushelTextArea from "@/components/common/forms/BushelTextArea.vue";
import DeleteConfirmationModal from "@/components/common/DeleteConfirmationModal.vue";
import BushelModal from "@/components/common/modals/BushelModal.vue";
import BModal from "@/components/base/BModal.vue";
import BTooltip from "@/components/base/BTooltip.vue";
import BPopover from "@/components/base/BPopover.vue";
import BCollapse from "@/components/base/BCollapse.vue";
import BButtonGroup from "@/components/base/BButtonGroup.vue";
import BDropdown from "@/components/base/BDropdown.vue";
import BDropdownItem from "@/components/base/BDropdownItem.vue";

// Vue-tables-2
const defaultTableOpt = {
  sortIcon: {
    base: "fa float-none ml-1",
    up: "fa-chevron-up",
    down: "fa-chevron-down",
    is: "fa-sort",
  },
  skin: "table",
  filterByColumn: true,
  perPage: 10,
  perPageValues: [],
  texts: {
    filterBy: "",
  },
};

export default (app) => {
  app.use(VueSecureHTML);
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        prefix: "p",
        darkModeSelector: "class",
        cssLayer: false,
      },
    },
  });
  app.use(ClientTable, defaultTableOpt, "bootstrap4");
  app.use(ServerTable, defaultTableOpt, "bootstrap4");

  app.component("BTooltip", BTooltip);
  app.component("BModal", BModal);
  app.component("BPopover", BPopover);
  app.component("BCollapse", BCollapse);
  app.component("BButtonGroup", BButtonGroup);
  app.component("BDropdown", BDropdown);
  app.component("BDropdownItem", BDropdownItem);

  // custom
  app.component("BushelBtn", BushelBtn);
  app.component("BushelCard", BushelCard);
  app.component("BushelTextInput", BushelTextInput);
  app.component("BushelSelect", BushelSelect);
  app.component("BushelTextArea", BushelTextArea);
  app.component("Loading", Loading);
  app.component("DeleteConfirmationModal", DeleteConfirmationModal);
  app.component("BushelModal", BushelModal);
};
// dayjsjs
